import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    BenefitGroupDto, BenefitGroupPaginator,
    CreateBenefitGroupDto,
    QueryBenefitGroupDto,
    SearchBenefitGroupDto,
    UpdateBenefitGroupDto
} from "../models/benefit-group.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetBenefitGroup(companyId: number, options?: QueryBenefitGroupDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BENEFITGROUP.GET;
    const request = (options: QueryBenefitGroupDto) => API.ProcessingCompanyAPI.getBenefitGroups(companyId,options);

    const { data, isLoading, error, refetch } = useQuery<BenefitGroupPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetBenefitGroupSearch(companyId: number) {

    return useMutation(
        (options?: SearchBenefitGroupDto) => API.ProcessingCompanyAPI.getBenefitGroupSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetBenefitGroupById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BENEFITGROUP.DETAIL;
    const request = API.ProcessingCompanyAPI.getBenefitGroupById(companyId,id);

    const {data, isLoading, error} = useQuery<{ data:BenefitGroupDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateBenefitGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateBenefitGroupDto}) => API.ProcessingCompanyAPI.createBenefitGroup(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BENEFITGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateBenefitGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateBenefitGroupDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateBenefitGroup(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BENEFITGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteBenefitGroup() {

    return useMutation(
        ({companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deleteBenefitGroupById(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}